import React from "react";
import { useApp } from "../../../state/Context";
import Card from "../ui/Card";

export default function Privacy() {
  const { setSelection } = useApp();

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      {/* Back */}
      <div className="flex items-center">
        <button
          type="button"
          onClick={() => setSelection((prev) => ({ ...prev, step: "select" }))}
          className="
            rounded-xl border border-neutral-200 bg-white px-3 py-2
            text-sm font-semibold text-neutral-800
            hover:bg-neutral-100
            dark:border-neutral-800 dark:bg-neutral-950
            dark:text-neutral-100 dark:hover:bg-neutral-900
          "
        >
          ← Back to selection
        </button>
      </div>

      <Card className="p-6">
        {/* Header */}
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">Privacy Policy</h1>
          <p className="text-sm text-neutral-600 dark:text-neutral-400">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Sections */}
        <div className="mt-6 space-y-4">
          {/* Overview */}
          <div className="rounded-lg border border-neutral-200 bg-neutral-50 p-4 dark:border-neutral-800 dark:bg-neutral-900">
            <h2 className="text-lg font-semibold">Overview</h2>
            <p className="mt-2 text-sm text-neutral-700 dark:text-neutral-200">
              Degree Classify UK is a calculator-style app. This policy explains what data we store,
              what we do not store, and how you can contact us for questions or data requests.
            </p>
          </div>

          {/* What we store */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">What we store</h2>
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-neutral-700 dark:text-neutral-200">
              <li>
                <span className="font-semibold">Account data</span>: email address, signup date, and
                last login date.
              </li>
              <li>
                <span className="font-semibold">Usage metrics</span>: page visits and calculation
                counts, stored as aggregate statistics.
              </li>
              <li>
                <span className="font-semibold">Pro subscription identifiers</span>: Stripe checkout
                ID and customer ID. We do not store full card details. These identifiers may be used
                to verify purchases in the event of billing disputes.
              </li>
            </ul>
          </div>

          {/* What we do not store */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">What we do not store</h2>
            <p className="mt-2 text-sm text-neutral-700 dark:text-neutral-200">
              We do not store your module credits, module grades, target grades, or any related
              user-entered calculation data. These values are processed in-memory to provide
              calculations and features, but are not retained as user data.
            </p>
          </div>

          {/* Third parties */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">Third parties and infrastructure</h2>
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-neutral-700 dark:text-neutral-200">
              <li>
                <span className="font-semibold">Firebase</span>: authentication and data storage.
              </li>
              <li>
                <span className="font-semibold">Stripe</span>: payment processing and Pro
                subscription management.
              </li>
              <li>
                <span className="font-semibold">IONOS</span>: domain hosting.
              </li>
              <li>
                <span className="font-semibold">PayPal</span>: donations.
              </li>
            </ul>
          </div>

          {/* Retention */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">Retention</h2>
            <p className="mt-2 text-sm text-neutral-700 dark:text-neutral-200">
              Accounts are retained until a user manually requests deletion. Usage and visit
              statistics may be retained and used to improve the product in the future.
            </p>
          </div>

          {/* Refunds */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">Refunds</h2>
            <p className="mt-2 text-sm text-neutral-700 dark:text-neutral-200">
              All purchases are final. No refunds are offered.
            </p>
          </div>

          {/* Contact */}
          <div className="rounded-lg border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-950">
            <h2 className="text-lg font-semibold">Contact</h2>
            <p className="mt-2 text-sm text-neutral-700 dark:text-neutral-200">
              For questions, improvements, or data requests, email{" "}
              <a
                className="font-semibold hover:underline"
                href="mailto:support@diceframe.co.uk"
              >
                support@diceframe.co.uk
              </a>
              .
            </p>
          </div>

          {/* Agreement note */}
          <div className="rounded-lg border border-neutral-200 bg-neutral-50 px-4 py-3 text-xs text-neutral-600 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-400">
            By using Degree Classify UK, you agree to this Privacy Policy. If you do not agree, please
            discontinue use of the app.
          </div>
        </div>
      </Card>
    </div>
  );
}
